<template>
  <div class="plkmap">
    <!-- app map -->
    <vl-map
      v-if="mapVisible"
      class="map"
      ref="map"
      :load-tiles-while-animating="true"
      :load-tiles-while-interacting="true"
      @click="clickCoordinate = $event.coordinate"
      @postcompose="onMapPostCompose"
      data-projection="EPSG:4326"
      @mounted="onMapMounted">
      <!-- map view aka ol.View -->
      <vl-view ref="view" :center.sync="center" :zoom.sync="zoom" :rotation.sync="rotation"></vl-view>

      <!-- interactions -->
      <vl-interaction-select :features.sync="selectedFeatures" style="background-color:red;">
        <template slot-scope="select">
          <!-- selected feature popup -->
          <vl-overlay
            class="feature-popup"
            v-for="feature in select.features"
            :key="feature.id"
            :id="feature.id"
            :position="pointOnSurface(feature.geometry)"
            :auto-pan="true"
            :auto-pan-animation="{ duration: 300 }">
              <template >
                <section class="card m-0 p-0">
                  <div class="card-content">
                    <div class="content">
                      <p class="mb-3">{{ feature.properties.country }}: {{ feature.properties.value }} {{$t(plkparams.metric)}}</p>
                      <button v-if="!haveFilters" @click="filterCountry(feature.properties.country)" class="pull-right">{{$t('plkmap.filter')}}</button>
                      <button v-if="haveFilters" @click="clearCountry(); selectedFeatures=[]" class="pull-right">{{$t('plkmap.clearall')}}</button>
                    </div>
                  </div>
                </section>
              </template>
          </vl-overlay>
          <!--// selected popup -->
        </template>
      </vl-interaction-select>
      <!--// interactions -->

      <!-- overlay marker with animation -->
      <vl-feature :id="point.country" :properties="{ country: point.country, value: point.value }" v-for="(point) in geoPoints" :key="point.country">
        <template slot-scope="feature">
          <vl-geom-point :coordinates="[point.coordinates[1], point.coordinates[0]]"></vl-geom-point>
          <vl-style-box>
            <vl-style-icon :src="plkparams.picker || 'picker.png'"></vl-style-icon>
          </vl-style-box>
          <!-- overlay binded to feature -->
          <vl-overlay v-if="feature.geometry" :position="pointOnSurface(feature.geometry)" :offset="[point.coordinates[1], point.coordinates[0]]">
          </vl-overlay>
        </template>
      </vl-feature>
      <!--// overlay marker -->

      <!-- base layers -->
      <vl-layer-tile v-for="layer in baseLayers" :key="layer.name" :id="layer.name" :visible="layer.visible">
        <component :is="'vl-source-' + layer.name" v-bind="layer"></component>
      </vl-layer-tile>
      <!--// base layers -->
    </vl-map>
    <!--// app map -->
  </div>
</template>

<script>
import Vue from 'vue'
import i18n from './i18n'
import configuration from './package.json'
import { findPointOnSurface } from 'vuelayers/lib/ol-ext'
import 'vuelayers/lib/style.css'
import VueLayers from 'vuelayers'
export const TYPE = 'plkmap'
Vue.use(VueLayers)

export default {
  name: TYPE,
  data () {
    return {
      center: [-3.749220, 40.463667],
      zoom: 5,
      rotation: 0,
      selectedFeatures: [],
      mapVisible: true,
      loading: false,
      countries: {
        'Alemania': [51.165691, 10.451526],
        'Andorra': [42.546245, 1.601554],
        'Arabia Saudita': [23.885942, 45.079162],
        'Argelia': [28.033886, 1.659626],
        'Argentina': [-38.416097, -63.616672],
        'Armenia': [40.069099, 45.038189],
        'Australia': [-25.274398, 133.775136],
        'Bélgica': [50.503887, 4.469936],
        'Bolivia': [-16.290154, -63.588653],
        'Brasil': [-14.235004, -51.925280],
        'Cabo Verde': [16.002082, -24.013197],
        'Canadá': [56.130366, -106.346771],
        'Chile': [-35.675147, -71.542969],
        'Chipre': [35.126413, 33.429859],
        'Colombia': [4.570868, -74.297333],
        'Costa Rica': [9.748917, -83.753428],
        'Croacia': [45.100000, 15.200000],
        'Egipto': [26.820553, 30.802498],
        'El Salvador': [13.794185, -88.896530],
        'Emiratos Árabes Unidos': [23.424076, 53.847818],
        'España': [40.463667, -3.749220],
        'Estados Unidos de América': [37.090240, -95.712891],
        'Etiopía': [9.145000, 40.489673],
        'Francia': [46.227638, 2.213749],
        'Georgia': [42.315407, 43.356892],
        'Grecia': [39.074208, 21.824312],
        'Guatemala': [15.783471, -90.230759],
        'Honduras': [15.199999, -86.241905],
        'Hong Kong': [22.396428, 114.109497],
        'India': [20.593684, 78.962880],
        'Italia': [41.871940, 12.567380],
        'Japón': [36.204824, 138.252924],
        'Kenya': [-0.023559, 37.906193],
        'Kosovo': [42.602636, 20.902977],
        'Malasia': [4.210484, 101.975766],
        'Malta': [35.937496, 14.375416],
        'Marruecos': [31.791702, -7.092620],
        'México': [23.634501, -102.552784],
        'Nicaragua': [12.865416, -85.207229],
        'Nueva Zelanda': [-40.900557, 174.885971],
        'Omán': [21.512583, 55.923255],
        'Panamá': [8.537981, -80.782127],
        'Paraguay': [-23.442503, -58.443832],
        'Perú': [-9.189967, -75.015152],
        'Polonia': [51.919438, 19.145136],
        'Portugal': [39.399872, -8.224454],
        'Qatar': [25.354826, 51.183884],
        'Reino Unido': [55.378051, -3.435973],
        'República Dominicana': [18.735693, -70.162651],
        'Serbia': [44.016521, 21.005859],
        'Singapur': [1.352083, 103.819836],
        'Sri Lanka': [7.873054, 80.771797],
        'Sudáfrica': [-30.559482, 22.937506],
        'Tailandia': [15.870032, 100.992541],
        'Taiwán': [23.697810, 120.960515],
        'Trinidad y Tobago': [10.691803, -61.222503],
        'Túnez': [33.886917, 9.537499],
        'Turquía': [38.963745, 35.243322],
        'Ucrania': [48.379433, 31.165580],
        'Uruguay': [-32.522779, -55.765835],
        'Venezuela': [6.423750, -66.589730]
      },
      cube: undefined,
      baseLayers: [
        {
          name: 'osm',
          title: 'OpenStreetMap',
          visible: true
        }
      ]
    }
  },
  computed: {
    haveFilters () {
      return (this.connectionStarted ? this.$store.getters['plaka/getFilters'](this.country.map(e => e.idElement)) : []).length > 0
    },
    country () {
      return this.plkparams.country ? [this.plkparams.country] : []
    },
    measure () {
      return this.plkparams.measure ? [this.plkparams.measure] : []
    },
    haveMeasure () {
      return this.measure.length
    },
    haveCountry () {
      return this.country.length
    },
    elements () {
      return this.country.concat(this.measure)
    },
    conditions () {
      return this.plkparams.conditions || []
    },
    geoPoints () {
      if (!this.cube || !this.haveCountry) {
        return []
      }
      let geo = []
      this.cube.getDimensionValues(this.plkparams.country.idElement).forEach((e, index) => {
        const geoCountry = this.countries[e.id]
        if (geoCountry) {
          geo.push({ country: e.id, coordinates: geoCountry, value: this.cube.getValues()[`${index}.0`] })
        }
      })
      return geo
    }
  },
  methods: {
    onInitComponent () {
      this.$servicesPLK.translation.init(i18n, { overwrite: false })
    },
    pointOnSurface: findPointOnSurface,
    onUpdatePosition (coordinate) {},
    onMapPostCompose ({ vectorContext, frameState }) {},
    onMapMounted () {
      this.$refs.map.$map.getControls().extend([])
    },
    getPackage () {
      return configuration
    },
    startData () {
      if (this.getConnection() && this.haveCountry && this.haveMeasure) {
        this.getConnection().initData(this.elements, this.conditions, { onInit: this.onInitLoad, onChange: this.onChangeData })
      } else {
        console.warn(`Necesary element type '${this.getConnection().ELEMENT_TYPES.COLUMN}' and '${this.getConnection().ELEMENT_TYPES.MEASURE}' to create plkmap`)
      }
    },
    filterCountry (country) {
      if (this.haveCountry) {
        let element = Object.assign({}, this.plkparams.country)
        element.values = [country]
        this.getConnection().applyFilter(element, { overwrite: true })
      }
    },
    clearCountry () {
      if (this.haveCountry) {
        this.getConnection().clearFilter(this.plkparams.country)
      }
    },
    onInitLoad () {
      Vue.set(this, 'loading', true)
    },
    onChangeData (cube) {
      Vue.set(this, 'cube', cube)
      Vue.set(this, 'loading', false)
    }
  },
  watch: {
    connectionStarted () {
      if (this.connectionStarted && this.getConnection().type === this.$servicesPLK.connection.TYPE.PLAKA) {
        this.startData()
      }
    }
  }
}
</script>

<style lang="sass">

html, body, #app
  width: 100%
  height: 100%
  margin: 0
  padding: 0

  .plkmap
    .feature-popup
      background: white
      padding: 10px
      max-width: 20vw
      overflow: scroll
      max-height: 20vh
      border-radius: 15px
      -webkit-box-shadow: 2px 2px 5px 0px rgba(0,0,0,0.75)
      -moz-box-shadow: 2px 2px 5px 0px rgba(0,0,0,0.75)
      box-shadow: 2px 2px 5px 0px rgba(0,0,0,0.75)

  .vld-demo-app
    position: relative

    .map
      height: 100%
      width: 100%

    .map-panel
      padding: 0

      .panel-block
        &.draw-panel
          .buttons
            .button
              display: block
              flex: 1 1 100%

    .base-layers-panel
      position: absolute
      left: 50%
      bottom: 20px
      transform: translateX(-50%)

    .feature-popup
      position: absolute
      left: -50px
      bottom: 12px
      width: 20em
      max-width: none

      &:after, &:before
        top: 100%
        border: solid transparent
        content: ' '
        height: 0
        width: 0
        position: absolute
        pointer-events: none
      &:after
        border-top-color: white
        border-width: 10px
        left: 48px
        margin-left: -10px
      &:before
        border-top-color: #cccccc
        border-width: 11px
        left: 48px
        margin-left: -11px

      .card-content
        max-height: 20em
        overflow: auto

      .content
        word-break: break-all
</style>
